export default __webpack_public_path__ + "static/home-inspirations-bg-2fa5a5628e0ec05f777d9d3c79494636.png";